'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const FatigueMeterType=require('../../../dist-es6/shared/domain/fatigueMeterType');
const BaseDirective=require('../../../dist-es6/client/angularCommon/baseDirective');let

FaviconDirective=function(){function FaviconDirective(){_classCallCheck(this,FaviconDirective)}FaviconDirective.prototype.




factory=function factory($rootScope,elementService,userService,$window,fatigueMeterTypeContentProviderService){
const _updateFavicon=function(){
const faviconUrl=fatigueMeterTypeContentProviderService.faviconUrl;

fastdom.mutate(function(){
elementService.setAttributeIfNew('link[rel="icon"]','href',faviconUrl);
elementService.setAttributeIfNew('link[rel="shortcut icon"]','href',faviconUrl);
elementService.setAttributeIfNew('meta[name="msapplication-TileImage"]','content',faviconUrl);
});
};

angular.element($window).on('load',function(){return _updateFavicon()});

return{
restrict:'A',
link:function(){
$rootScope.$on('$stateChangeSuccess',function(){return _updateFavicon()});
}};

};_createClass(FaviconDirective,null,[{key:'type',get:function(){return'directive'}}]);return FaviconDirective}();

module.exports=FaviconDirective;
module.exports.prototype.factory.$inject=['$rootScope','elementService','userService','$window','fatigueMeterTypeContentProviderService'];
//# sourceMappingURL=faviconDirective.js.map
